import subjectMaker from 'reducersMakers/subjectMaker';
import * as actions from 'actions';

export default subjectMaker({
  updateType: actions.FEEDBACK_EDITING_UPDATE_SUBJECT,
  resetType: actions.FEEDBACK_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/subject/reducer.js
 **/